import { useContext } from 'react';

import { AuthContext } from '../context/AuthContextProvider';

export const useAuthContext = () => useContext(AuthContext);
